
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/options",
      function () {
        return require("private-next-pages/section/options.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/options"])
      });
    }
  